export const GET_AKW_ANALYTICS_REPORT_DATA_START = 'GET_AKW_ANALYTICS_REPORT_DATA_START';
export const GET_AKW_ANALYTICS_REPORT_DATA_SUCCESS = 'GET_AKW_ANALYTICS_REPORT_DATA_SUCCESS';
export const GET_AKW_ANALYTICS_REPORT_DATA_FAILED = 'GET_AKW_ANALYTICS_REPORT_DATA_FAILED';

export const GET_AKW_ANALYTICS_WEEKLY_REPORT_DATA_START = 'GET_AKW_ANALYTICS_WEEKLY_REPORT_DATA_START';
export const GET_AKW_ANALYTICS_WEEKLY_REPORT_DATA_SUCCESS = 'GET_AKW_ANALYTICS_WEEKLY_REPORT_DATA_SUCCESS';
export const GET_AKW_ANALYTICS_WEEKLY_REPORT_DATA_FAILED = 'GET_AKW_ANALYTICS_WEEKLY_REPORT_DATA_FAILED';

export const getAKWAnalyticsReportDataStart = () => ({
  type: GET_AKW_ANALYTICS_REPORT_DATA_START,
});

export const getAKWAnalyticsReportDataSuccess = (data) => ({
  type: GET_AKW_ANALYTICS_REPORT_DATA_SUCCESS,
  data
});

export const getAKWAnalyticsReportDataFailed = (error) => ({
  type: GET_AKW_ANALYTICS_REPORT_DATA_FAILED,
  error
});

export const getAKWAnalyticsWeeklyReportDataStart = () => ({
  type: GET_AKW_ANALYTICS_WEEKLY_REPORT_DATA_START
});

export const getAKWAnalyticsWeeklyReportDataSuccess = (data) => ({
  type: GET_AKW_ANALYTICS_WEEKLY_REPORT_DATA_SUCCESS,
  data
});

export const getAKWAnalyticsWeeklyReportDataFailed = (error) => ({
  type: GET_AKW_ANALYTICS_WEEKLY_REPORT_DATA_FAILED,
  error
});
